import { API_HEADERS } from '../constants/apiHeaders';
import api from '../utils/api';
import { SETTINGS_ENDPOINTS } from './endpoints/settings.endpoints';
import type { DropdownOption } from './types/userProfile.types';

type ListEnvelope<T> = { data: T; count: number };

export const settingsService = {
  getUserRoles: () =>
    api.get<ListEnvelope<DropdownOption[]>>(SETTINGS_ENDPOINTS.userRoles, {
      headers: API_HEADERS.USER_PROFILE_USER_ROLES,
    }),

  getPermissionLevels: () =>
    api.get<ListEnvelope<DropdownOption[]>>(SETTINGS_ENDPOINTS.permissionLevels, {
      headers: API_HEADERS.USER_PROFILE_PERMISSION_LEVELS,
    }),

  getEmploymentTypes: () =>
    api.get<ListEnvelope<DropdownOption[]>>(SETTINGS_ENDPOINTS.employmentTypes, {
      headers: API_HEADERS.USER_PROFILE_EMPLOYMENT_TYPES,
    }),

  getFunctionalTeams: () =>
    api.get<ListEnvelope<DropdownOption[]>>(SETTINGS_ENDPOINTS.functionalTeams, {
      headers: API_HEADERS.USER_PROFILE_FUNCTIONAL_TEAMS,
    }),
};
